import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { DocumentGenerationParamsView } from "./DocumentGenerationParamsView";
import { DocumentGenerationParamsViewStore } from "../../store/DocumentGenerationParamsViewStore";
import { useStore } from "../../../../hooks";

export const DocumentGenerationParamsViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/documentGenerationParams/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new DocumentGenerationParamsViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <DocumentGenerationParamsView
          documentGenerationParamsViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
